import { Box } from "@chakra-ui/react";

export function FailedConsolidatedPage() {
  return (
    <Box mt={5} py={10} px={8} borderRadius={10} textAlign="center">
      Failed to get consolidated bundle. If the problem persists, please reach out to
      support@metriport.com.
    </Box>
  );
}
